import SaveIcon from '../../assets/images/svgicons/save.svg';
import PlayIcon from '../../assets/images/svgicons/play.svg';
import UnsaveIcon from '../../assets/images/svgicons/unsave.svg';
import MicIcon from '../../assets/images/svgicons/mic.svg';
import BulletinIcon from '../../assets/images/svgicons/bulletin.svg';
import DocumentIcon from '../../assets/images/svgicons/document.svg';
import BookIcon from '../../assets/images/svgicons/book.svg';
import {useNavigate} from 'react-router-dom';

import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
  useToast
} from 'alm-react-components';
import {constants, DateFormat, Tag} from '../../assets/constants/constants';
import {defaultImage} from '../../lib/utils';
import {useTranslation} from 'react-i18next';
import getLocalizedContent from '../../lib/getLocalizedMetaData';
import { apis } from '../../services/alm';
import moment from 'moment-timezone';
const CarouselSection = ({
  data,
  deleteBookMark,
  addBookMark,
  type,
  id,
  filterTag,
  from,
  catId
}: {
  data: any;
  addBookMark?: any;
  deleteBookMark: any;
  type: any;
  seeAll?: boolean;
  id?: any;
  filterTag?: any;
  from?:string;
  catId?:any
}) => {
  let routing = '';
  const navigate = useNavigate();
  const {t} = useTranslation();
  const {toast}=useToast()
  const playIcon = (name: any) => {
    if (name === constants.PODCAST) {
      routing = `/${constants.S_PODCAST}/${id}`;
      return MicIcon;
    }
    if (name === constants.VIDEOS) {
      routing = `/${constants.S_VIDEOS}/${id}`;
      return PlayIcon;
    }
    if (name === constants.BULLETIN || name === constants.BULLETINS) {
      routing = `/${constants.S_BULLETIN}/${id}`;
      return BulletinIcon;
    }
    if (name === constants.DOCUMENTS) {
      routing = `/${constants.S_DOCUMENT}/${id}`;
      return DocumentIcon;
    }
    if (name === constants.BOOKS) {
      routing = `/${constants.S_BOOKS}/${id}`;
      return BookIcon;
    }
    if (name === constants.MY_BOOKMARK) {
      routing = `/${constants.MY_BOOKMARK}`;
      return PlayIcon;
    }
    if (name ===  constants.RECOMMENDED) {
      routing = `/${constants.RECOMMENDED}`;
      return PlayIcon;
    }
  };
  const enrollCourse = async (id: any) => {
    const response: any = await apis.getProgramList(id);
    if(response && type!==constants.MY_BOOKMARK){
      try{
          await apis.userEnroll(id, response?.data?.relationships?.instances?.data[0].id);
      }catch(error){
        toast({
          description: t("common.noEnrollment"),
          color: 'white',
          variant: 'error',
        });
      }
    }
    if (filterTag) {
      navigate(`/home/library/library-course/${id}?catId=${catId}`,{state:{courseType:encodeURIComponent(type),filterTag:filterTag,from:from}});
    } else if(type === constants.VIDEOS) {
      navigate(`/home/library/library-course/${id}`,{state:{courseType:encodeURIComponent(type),filterationTag:constants.NEW_VIDEO,from:from}});
    }
    else if(type === constants.DOCUMENTS) {
      navigate(`/home/library/library-course/${id}`,{state:{courseType:encodeURIComponent(type),filterationTag:constants.NEW_DOCUMENT,from:from}});
    }
    else if(type === constants.BULLETINS) {
      navigate(`/home/library/library-course/${id}`,{state:{courseType:encodeURIComponent(type),filterationTag:constants.NEW_BULLETINS,from:from}});
    }else{
      navigate(`/home/library/library-course/${id}`,{state:{courseType:encodeURIComponent(type),filterationTag:type,from:from}});
    }
  };
  return (
    <>
      <Carousel className="mt-6 md:mt-12">
        <CarouselContent className="lg:flex-row lg:gap-0 md:gap-0 md:flex md:flex-row">
          {data?.length &&
            data
              ?.slice(
                0,
                window.location.pathname === constants.SEE_MORE_PATHNAME ||
                  window.location.pathname === constants.SEE_MORE_PATHNAME2
                  ? constants.SEE_MORE_LIMITS
                  : data.length
              )
              .map((res: any, index: number) => {
                const content = getLocalizedContent(res?.attributes?.localizedMetadata);
                const releaseDate = res?.attributes?.tags
                  ?.filter((item: any) => item?.split(':')[0] === Tag.releaseDate)[0]
                  ?.split(':')[1];
                return (
                  <>
                    <CarouselItem
                      key={index + '_' + res?.id}
                      className="landscape:2xl:basis-1/4 landscape:xl:basis-1/4 landscape:lg:basis-1/3 landscape:md:basis-1/2 portrait:md:basis-1/2 landscape:sm:basis-1/2 portrait:sm:basis-1/2 md:pl-5"
                    >
                      <Card
                        onClick={() => enrollCourse(res?.id)}
                        className="w-full h-full p-0 bg-fillMidGrayCard cursor-pointer border-cardBorder relative"
                      >
                        <CardHeader className="p-0 min-h-[130px]">
                          <div className={`relative cursor-pointer]`}>
                            {res?.attributes?.imageUrl ? (
                              <img
                                src={res?.attributes?.imageUrl}
                                alt={' '}
                                className="rounded-t-xl w-full h-full aspect-[3/2] object-cover"
                              />
                            ) : (
                              <img
                                src={defaultImage()}
                                alt={' '}
                                className="rounded-t-xl w-full h-full aspect-[3/2] object-cover"
                              />
                            )}
                            <img src={playIcon(type)} alt={' '} className="absolute  center-icon" />
                          </div>
                        </CardHeader>
                        <CardContent className="mt-4 px-5">
                          <div className="flex flex-row items-start justify-between mt-2 h-full">
                            <div className="flex flex-col justify-between">
                              <div className="flex flex-col">
                                <CardTitle className="text-wrap text-xl lg:text-2xl xl:text-2xl font-barlowMedium leading-normal">
                                  {content?.name}
                                </CardTitle>
                                <p className="lg:text-base xl:text-lg font-opensansRegular mt-2 mb-10 flex-grow">
                                  {content?.description}
                                </p>
                              </div>
                              <p className="text-base font-opensansMedium absolute bottom-6">
                                {/* {formatDate(releaseDate?releaseDate:"")} */}
                                <span className="capitalize">
                                  {releaseDate && moment(releaseDate).isValid()
                                    ? moment(releaseDate).format(DateFormat)
                                    : ""}
                                </span>
                              </p>
                            </div>
                            <img
                              onClick={(e) => {
                                e.stopPropagation();
                                res.attributes?.isBookmarked
                                  ? deleteBookMark(res?.id)
                                  : addBookMark(res?.id);
                              }}
                              src={
                                res?.attributes?.isBookmarked
                                  ? SaveIcon
                                  : UnsaveIcon
                              }
                              alt="No image"
                              className="ms-5 cursor-pointer"
                            />
                          </div>
                        </CardContent>
                      </Card>
                    </CarouselItem>
                  </>
                );
              })}
          {data?.length > constants.SEE_MORE_LIMITS &&
            (window.location.pathname === constants.SEE_MORE_PATHNAME ||
              window.location.pathname === constants.SEE_MORE_PATHNAME2 ||
              window.location.pathname === constants.SEE_MORE_PATHNAME1) && (
              <CarouselItem
                key={data.length + '_' + window.location.pathname}
                className="landscape:2xl:basis-1/4 landscape:xl:basis-1/4 landscape:lg:basis-1/3 landscape:md:basis-1/2 portrait:md:basis-1/2 landscape:sm:basis-1/2 portrait:sm:basis-1/2 md:pl-5"
              >
                <Card
                  onClick={() => navigate(routing)}
                  className="w-full h-full p-0 bg-fillMidGrayCard cursor-pointer border-cardBorder relative flex items-center justify-center"
                >
                  <CardContent className="mt-4 px-5  ">
                    <div className="text-2xl">{t('Common.seeMore')}</div>
                  </CardContent>
                </Card>
              </CarouselItem>
            )}
        </CarouselContent>
        <div className="carousel-prev-next-box">
          <CarouselPrevious className="carousel-prev-btn top-full mt-5 translate-y-0" />
          <CarouselNext className="carousel-next-btn right-0 top-full bottom-0 mt-5 translate-y-0" />
        </div>
      </Carousel>
    </>
  );
};

export default CarouselSection;
